export default {
  textAlign: 'center',
  padding: 10,
};



// WEBPACK FOOTER //
// ./src/Components/Loading/style.js